<template>
  <textarea
    v-if="code === ''"
    v-model="content"
    :disabled="disabled"
  />
  <codemirror
    v-else
    v-model="content"
    class="text-left h-100"
    :options="cmOptions"
  />
</template>

<script>
import { codemirror } from 'vue-codemirror';
// eslint-disable-next-line
import 'codemirror/mode/javascript/javascript.js';
// eslint-disable-next-line
import 'codemirror/lib/codemirror.css';
// eslint-disable-next-line
import 'codemirror/theme/base16-dark.css';
// eslint-disable-next-line
import 'codemirror/theme/base16-light.css';
export default {
  name: 'BaseTextarea',
  components: { codemirror },
  props: {
    value: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
    light: {
      type: Boolean,
      default: false,
    },
    // TODO: Implement for codemirror with readOnly setting.
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      content: 'const a = 10',
      cmOptions: {
        tabSize: 2,
        mode: this.code,
        theme: this.themeString,
        lineNumbers: true,
        line: true,
      },
    };
  },
  computed: {
    themeString() {
      return this.light ? 'base16-light' : 'base16-dark';
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.content = newVal;
      },
      immediate: true,
    },
    content(newVal) {
      this.$emit('input', newVal);
    },
    light: {
      handler(newVal) {
        this.cmOptions.theme = this.themeString;
      },
      immediate: true,
    },
  },
  mounted() {
    this.cmOptions = { mode: this.code, ...this.cmOptions };
  },
};
</script>
<style lang="scss" scoped>
  .vue-codemirror {
    ::v-deep > .CodeMirror {
      height: 100%;
    }
  }
</style>
